import React, { useMemo } from 'react';

import FieldError from '../../helper/FieldError';
import {
  inputId,
  inputName,
} from '../../helper/form';

import { Row, Col, FormGroup, Input, Label } from 'reactstrap'

const DocumentRejectionNotificationSettings = props => {
  const {
    resource,
    callbacks: {
      setResource: onSetResource
    },
    configuration: {
      formName = 'document'
    } = {}
  } = props;

  const showRejectionNotificationSettings = useMemo(() => {
    return resource.require_signers
  }, [resource.require_signers])

  const onChangeNotification = (event, key) => {
    let value = event.target.value;

    if(event.target.type === 'checkbox') {
      value = event.target.checked
    }

    let updatedAttributes = {
      [key]: value
    }

    // Si las notificaciones de rechazo se desactivan, se desactivan las notificaciones de firmantes y creador
    if(key === 'rejection_notification_enabled' && !value) {
      updatedAttributes['rejection_notification_send_to_signers'] = false
      updatedAttributes['rejection_notification_send_to_creator'] = false
    }

    onSetResource(prevState => {
      return { ...prevState, ...updatedAttributes }
    })
  }
  // ========== START ENABLED NOTIFICATION ==========

  const notificationEnabled = useMemo(() => {
    return resource.rejection_notification_enabled
  }, [resource.rejection_notification_enabled])

  const notificationEnabledSwitchInput = () => {
    return(
      <FormGroup tag="span">
        <div className='custom-switch'>
          <FieldError errors={ _.get(resource, 'errors.rejection_notification_enabled') || [] }>
            <Input
              className='custom-control-input'
              type='checkbox'
              name={ inputName(formName, 'rejection_notification_enabled') }
              id={ inputId(formName, 'rejection_notification_enabled') }
              invalid={ _.has(resource, 'errors.rejection_notification_enabled') }
              onChange={ event => onChangeNotification(event, 'rejection_notification_enabled') }
              checked={ resource?.rejection_notification_enabled }
            />
             <Label
                className='custom-control-label'
                for={ inputId(formName, 'rejection_notification_enabled') }
              >
                { I18n.t(`activerecord.attributes.document.rejection_notification_enabled`) }
              </Label>
          </FieldError>
        </div>
      </FormGroup>
    )
  }
  // ========== END ENABLED NOTIFICATION ==========
  // ========================================
  // ========== START SEND TO SIGNERS NOTIFICATION ==========
  const sendToSignersSwitchInput = () => {
    if(!notificationEnabled) return null;

    return(
      <FormGroup tag="span">
        <div className='custom-switch'>
          <FieldError errors={ _.get(resource, 'errors.rejection_notification_send_to_signers') || [] }>
            <Input
              className='custom-control-input'
              type='checkbox'
              name={ inputName(formName, 'rejection_notification_send_to_signers') }
              id={ inputId(formName, 'rejection_notification_send_to_signers') }
              invalid={ _.has(resource, 'errors.rejection_notification_send_to_signers') }
              onChange={ event => onChangeNotification(event, 'rejection_notification_send_to_signers') }
              checked={ resource?.rejection_notification_send_to_signers }
            />
             <Label
                className='custom-control-label'
                for={ inputId(formName, 'rejection_notification_send_to_signers') }
              >
                { I18n.t(`activerecord.attributes.document.rejection_notification_send_to_signers`) }
              </Label>
          </FieldError>
        </div>
      </FormGroup>
    )
  }
  // ========== END SEND TO SIGNERS NOTIFICATION ==========

  // ========================================
  // ========== START SEND TO CREATOR NOTIFICATION ==========
  const sendToCreatorSwitchInput = () => {
    if(!notificationEnabled) return null;

    return(
      <FormGroup tag="span">
        <div className='custom-switch'>
          <FieldError errors={ _.get(resource, 'errors.rejection_notification_send_to_creator') || [] }>
            <Input
              className='custom-control-input'
              type='checkbox'
              name={ inputName(formName, 'rejection_notification_send_to_creator') }
              id={ inputId(formName, 'rejection_notification_send_to_creator') }
              invalid={ _.has(resource, 'errors.rejection_notification_send_to_creator') }
              onChange={ event => onChangeNotification(event, 'rejection_notification_send_to_creator') }
              checked={ resource?.rejection_notification_send_to_creator }
            />
             <Label
                className='custom-control-label'
                for={ inputId(formName, 'rejection_notification_send_to_creator') }
              >
                { I18n.t(`activerecord.attributes.document.rejection_notification_send_to_creator`) }
              </Label>
          </FieldError>
        </div>
      </FormGroup>
    )
  }
  // ========== END SEND TO CREATOR NOTIFICATION ==========



  return (
    showRejectionNotificationSettings ? (
      <Row>
        <Col>
          <div className="card overflow-hidden">
            <div className="list-group list-group-flush">
              <div className="list-group-item fw-bold bg-real-light">
                <i className="fas fa-signa"></i>
                Configuración de notificaciones de rechazo
              </div>
              <div className="list-group-item">
                { notificationEnabledSwitchInput() }
              </div>

              { notificationEnabled && (
                <>
                  <div className="list-group-item">
                    { sendToSignersSwitchInput() }
                  </div>

                  <div className="list-group-item">
                    { sendToCreatorSwitchInput() }
                  </div>
                </>
              )}
            </div>
          </div>
        </Col>
      </Row>
    ) : null
  )
}

export default DocumentRejectionNotificationSettings;
